<template>
<v-dialog v-model="dialog" @keydown.esc="cancel()">
      <div fill-height class="fill-height pa-0 justify-center text-xs-center" style="width:100%">
        <v-slide-y-transition mode="out-in">
          <v-layout row wrap justify-center text-xs-center>
            <v-flex xs12 >
              <div class="camera">
              <div class="camera-modal">
                <video ref="video" class="camera-stream" autoplay muted playsinline width="100%" heigth="100%"/>

                <div class="take-picture-button">
                  <v-btn
                    color="primary"
                    dark
                    fab
                    @click.prevent="capture"
                  >
                    <v-icon>camera_alt</v-icon>
                  </v-btn>
                  </div>
                </div>

              </div>
            </v-flex>
          </v-layout>

        </v-slide-y-transition>

      </div>
  </v-dialog>
</template>

<script>
import '@/polyfill/imagecapture';

export default {
  props: {
    selectedCallback: Function
  },
  data () {
    return {
      id: null,
      dialog: false,
      resolve: null,
      reject: null,
      mediaStream: null,
      facingMode: 'enviroment'
    };
  },
  mounted () {
    // this.startCamera();
  },
  destroyed () {
    this.stopCamera()
  },
  methods: {
    cancel () {
      this.stopCamera();
      this.resolve(false);
      this.dialog = false;
    },
    open (id) {
      this.dialog = true;
      this.id = id;
      this.startCamera();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    stopCamera () {
      this.dialog = false;
      if (this.mediaStream) {
        const tracks = this.mediaStream.getTracks();
        tracks.map(track => track.stop());
      }
    },
    startCamera () {
      var app = this;
      this.facingMode = 'enviroment';
      var constraints = {
        audio: false,
        video: {
          facingMode: this.facingMode
        }
      };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function success (mediaStream) {
          app.mediaStream = mediaStream;
          app.$refs.video.srcObject = mediaStream;
        })
        .catch(error => console.error('getUserMedia() error:', error));
    },
    capture () {
      var app = this;
      const mediaStreamTrack = this.mediaStream.getVideoTracks()[0];

      const imgCapture = new window.ImageCapture(mediaStreamTrack);

      return imgCapture.takePhoto().then(blob => {
        if (blob) {
          this.stopCamera()
          app.resolve(blob);
        } else {
          app.reject(null);
        }

       /* storage
          .ref()
          .child('images/picture' + new Date().getTime())
          .put(blob)
          .then(res => {
            console.log(res.metadata.downloadURLs);
            this.postTicket(this.id, res.metadata.downloadURLs[0], 'Ticket');
          });
        */
      });
    }
  },
  watch: {
    dialog (value) {
      if (!value) {
        this.stopCamera();
      }
    }
  }
};
</script>

<style scoped>
.camera {
  position: relative;
}
.camera-modal {
  background-color: #e5332a !important;
}
.camera-stream {
  width: 100%;
  max-height: 480px;
}

.take-picture-button {
  width: 100%;
  position: absolute;
  bottom: 15px;
  z-index: 1;
}
</style>
